import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react"

import { Alert, CircularProgress, Divider, Snackbar } from "@mui/material"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth"
import { URL } from "../../common/api/urls"
import useAuth from "../../common/hooks/useAuth"
import usePermissions from "../../common/hooks/usePermissions"
import useSyncUidataNotifyFlags from '../../common/hooks/useSyncUidataNotifyFlags';
import {
  BOOKMARK_CATEGORY_AUTOSAVE,
  CONSTANTS,
  MP_CHART_RELOAD_TIME,
  SNACKBAR_AUTO_HIDE_DURATION,
  TEXT_MSGS,
  TIME_FRAME_VALUES,
  USER_ROLE_FIELDS,
} from "../../common/utility/constant"
import { breakDSTR, isChartOptionAccessAllowed, isD3BasedLineChart, transformAndReverseMap, useQuery } from "../../common/utility/helperFunc"
import {
  CHART_TYPE,
  MAX_PROFILE_TO_LOAD,
  VA_TYPE,
  VP_TYPE,
} from "../../common/utility/mp_chart_constants"
import { UserSettingsContext } from "../../setup/routes-manager/RequireAuth"
import LineChartFooterNew from "./components/LineChartFooterNew"

import LineChart from "./line_chart"
import OrderflowContainer from "./orderflow_container"
import StockChartHV from "./stock_chart_hv"
import ChartContainer from "./chart_container"
import BarChartContainer from "./BarChartContainer";
import LineChartSettings from "./components/lc_settings"
import LineChartSettingsNew from "./components/lc_settings_new"

// const DEFAULT_PROFILE_WIDTH=120;
// const DEFAULT_PROFILE_WIDTH_WEEKLY=200;
// const DEFAULT_PROFILE_WIDTH_MONTHLY=200;
// const DEFAULT_PROFILE_WIDTH_YEARLY=400;
const DEFAULT_PROFILE_WIDTH = 60
const DEFAULT_PROFILE_WIDTH_WEEKLY = 100
const DEFAULT_PROFILE_WIDTH_MONTHLY = 120
const DEFAULT_PROFILE_WIDTH_YEARLY = 400
const PROFILE_LOAD_FACTOR = 1.2

const LineChartContainer = (props) => {
  // console.log("props==========================>",props);
  const [tabData,setTabData]=useState(props?.tabData??undefined)
  const [initialData,setInitialData]=useState((props?.tabData?.data?.[props.val] &&props?.tabData?.data?.[props.val].type) ?props?.tabData?.data?.[props.val]: undefined)
  const [toggleState,setToggleState]=useState(true);
  const { auth, setAuth } = useAuth()
  const syncUidataNotifyFlags = useSyncUidataNotifyFlags();
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  const isEliteUser = permissions.isEliteUser();
  const location = useLocation()
  // const [chartType, setChartType] = useState(
  //   props.chartType ? props.chartType : CHART_TYPE.LINE_CHART
  // )
  const [chartType, setChartType] = useState(initialData?.type ?? props.chartType ?? CHART_TYPE.LINE_CHART);
  const { userSettings, setUserSettings } = useContext(UserSettingsContext)
  const from = "/login"
  const symbol = useQuery("symbol")
  // console.log("testing 1=", props.key, props.val,symbol,props.symbol)
  console.log("chartType", chartType);
  const [state, setState] = useState({
    isLoading: true,
    liveData: undefined,
    chartData: undefined,
    krlData: undefined,
    instrument: props.symbol
      ? props.symbol
      : symbol && props.val == 0
      ? symbol
      : userSettings.data.default_instrument,
    // instrument:symbol&&props.val==0?symbol:userSettings.data.default_instrument,
    isIncrementalData: false,
    lastLoadTime: -1,
    isInstrumentLive: false,
    // OLD - Hardcoded FAST_DATA role check (DEPRECATED)
    // Replaced by: permissions.getChartReloadInterval()
    // reloadInerval: auth.role.find((el) => el == USER_ROLE_FIELDS.FAST_DATA)
    //   ? MP_CHART_RELOAD_TIME.FAST_DATA
    //   : MP_CHART_RELOAD_TIME.SLOW_DATA,
    // NEW - Use centralized permission service
    reloadInerval: permissions.getChartReloadInterval(),
    pollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,
    refreshInterval: -1,
    selectedTimeFrame: "1",
    isPollingAllowed: false,
    isTradingSessionActive: false,
    isJsonLoaded: false,
    isFirtLoadComplete: false,
    apiData: undefined,
    bookmarkData: undefined,
    isStatusCheckAllowed: false,
    statusCheckPollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,
    isLivePollingAllowed: false,
    krlPollingTime: MP_CHART_RELOAD_TIME.KRL_POLLING_TIME,
    krlPollingAllowed: false,
    tradeDates: undefined,
    dstrData: undefined,
    chartRendered:false,
   
  })
  const [
    cancelUiData,
    responseDataUiData,
    errorUiData,
    loadedUiData,
    resetUiData,
    executeAPIUiData,
  ] = useAxiosWithAuth()
  const [selectedInstrumentData, setSelectedInstrumentData] = React.useState()
  const [selectedInstrument, setSelectedInstrument] = React.useState("")
  const [instrumentsData, setInstrumentsData] = useState()
  const [instrumentsLoaded, setInstrumentsLoaded] = useState(false);
 

  const [footerLoaded, setFooterLoaded] = useState(false)
  // OLD - Hardcoded FAST_DATA role check (DEPRECATED)
  // Replaced by: permissions.isPremiumUser()
  // const [npocAllowed, setNPOCAllowed] = useState(
  //   auth.role.find((el) => el == USER_ROLE_FIELDS.FAST_DATA) ? true : false
  // )
  // NEW - Use centralized permission service
  const [npocAllowed, setNPOCAllowed] = useState(permissions.isPremiumUser())

  const [msgState, setMsgState] = useState({
    open: false,
    msg: "",
    severity: "info",
  })

  const { open, msg, severity } = msgState

  const {
    isLoading,
    chartData,
    liveData,
    krlData,
    isIncrementalData,
    isInstrumentLive,
    lastLoadTime,
    reloadInerval,
    pollingInterval,
    instrument,
    refreshInterval,
    selectedTimeFrame,
    isPollingAllowed,
    isTradingSessionActive,
    isJsonLoaded,
    isFirtLoadComplete,
    apiData,
    bookmarkData,
    isStatusCheckAllowed,
    statusCheckPollingInterval,
    isLivePollingAllowed,
    krlPollingTime,
    krlPollingAllowed,
    tradeDates,
    dstrData,
    chartRendered,
  } = state
  const stateRef = useRef(state)

  const [cancel, responseData, error, loaded, reset, executeAPI] =
    useAxiosWithAuth()
  const [
    cancelLive,
    responseDataLive,
    errorLive,
    loadedLive,
    resetLive,
    executeLive,
  ] = useAxiosWithAuth()
  const [
    cancelSaved,
    responseDataSaved,
    errorSaved,
    loadedSaved,
    resetSaved,
    executeAPISaved,
  ] = useAxiosWithAuth()
  const [
    cancelDelete,
    responseDataDelete,
    errorDelete,
    loadedDelete,
    resetDelete,
    executeAPIDelete,
  ] = useAxiosWithAuth()
  const [
    cancelStatus,
    responseDataStatus,
    errorStatus,
    loadedStatus,
    resetStatus,
    executeAPIStatus,
  ] = useAxiosWithAuth()
  const [
    cancelKRL,
    responseDataKRL,
    errorKRL,
    loadedKRL,
    resetKRL,
    executeAPIKRL,
  ] = useAxiosWithAuth()
  const [
    cancelKRLPoll,
    responseDataKRLPoll,
    errorKRLPoll,
    loadedKRLPoll,
    resetKRLPoll,
    executeAPIKRLPoll,
  ] = useAxiosWithAuth()

  const selectedInstrumentRef = useRef(selectedInstrument)
  const [selectedTPO, setSelectedTPO] = useState(2)
  const [selectedInstrumentTPOData, setSelectedInstrumentTPOData] = useState()
  const [globalVolumeVisible, setGlobalVolumeVisible] = useState(
    userSettings.data.show_global_vp
  )
  const [volumeNumberVisible, setVolumeNumberVisible] = useState(
    userSettings.data.show_global_vp_numbers
  )
  const [onlyVolumeProfile, setOnlyVolumeProfile] = useState(false)
  const [tpoOnVolume, setTpoOnVolume] = useState(false)
  const [perProfilelVolumeVisible, setPerProfileVolumeVisible] = useState(false)
  const [perProfileVolumeNumberVisible, setProfileVolumeNumberVisible] =
    useState(false)
  const navigate = useNavigate()
  const [autoCenter, setAutocenter] = useState(false)
  // const [viewState, setViewState] = React.useState({tpo_only:true,vol_tpo_side:false,only_vol:false,tpo_on_vol:false});
  const [viewState, setViewState] = React.useState({
    tpo_only:
      userSettings.data.vp_type == VP_TYPE.NONE ||
      userSettings.data.vp_type == VP_TYPE.BACKGROUND,
    vol_tpo_side: userSettings.data.vp_type == VP_TYPE.ASIDE,
    only_vol: userSettings.data.vp_type == VP_TYPE.ALONE,
    tpo_on_vol: userSettings.data.vp_type == VP_TYPE.BACKGROUND,
  })

  const [tpoBasedVA, setTPOBasedVA] = useState(userSettings.data.va_type)
  const [toggleReset, setToggleReset] = useState(false)
  const [toggleUnselect, setToggleUnselect] = useState(false)
  const [rightPanelConatinerState, setRightPanelConatinerState] = useState({
    show: false,
    metadata: undefined,
    histoticalData: undefined,
    selectedIndexes: [],
    isLiveSession: false,
  })
  const [toggleSave, setToggleSave] = useState(false)
  const [toggleSaveBookmark, setToggleBookmark] = useState(false)
  const [jsonData, setJsonData] = useState()
  const [vpType, setVPType] = React.useState(userSettings.data.vp_type)
  const [stateData, setStateData] = useState(props.stateData)
  const [plotType, setPlotType] = useState(
    props.stateData?.data?.plot ?? "fut",
  )
  const [plotData, setPlotData] = useState(
    props.stateData?.data ?? { plot: "fut", doix: false },
  )
  const [openAutosaveDeleteDialog, setOpenAutosaveDeleteDialog] =
    useState(false)
  const [reloadInstrument, setReloadInstrument] = useState()
  const [isDirty, setIsDirty] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [toggleMPLoading, setToggleMPLoading] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState(false)
  const [levelData, setLevelData] = useState([-1, -1]);
  const [showSettings,setShowSettings]=useState(false);

  const openStockChart = () => {
    navigate(
      `/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`,
      { replace: false }
    )
  }

  useEffect(() => {
    // executeAPIKRL(URL.GET_KRL_LIST,"POST",{"symbol":"NIFTY"})
    console.log("props LC container=", props)
    if (props.setChartType) props.setChartType(chartType)
      const timeout = setTimeout(() => {
        setTabData(undefined);
        setInitialData(undefined);
        console.log("Reload props LC container setInitialData=undefined"); 
    }, 1000);
    return () => {
      // just to clear the timeout when component unmounts
      clearTimeout(timeout)
    }
  }, [])

  const openMPChart = () => {
    setShowTable(false)
    if (chartType != CHART_TYPE.MARKET_PROFILE) {
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel()
      // console.log("state=",state);
      setPollingAllowedVal(true)
      setChartType(CHART_TYPE.MARKET_PROFILE)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.MARKET_PROFILE)

      // setState((prevState) => ({
      //   ...prevState,
      //   isLoading:false}));

      // setSelectedInstrument(selectedInstrument);
    }
    // navigate(`/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });
  }

  const openLineChart = () => {
    // if (chartType != CHART_TYPE.LINE_CHART) {
      console.log("selected instrument", props.val, selectedInstrument)
      console.log("live panel resetRightPanel===2")
      props.resetRightPanel()
      setPollingAllowedVal(false)
      setStateData(undefined);
      setToggleState(!toggleState);
      setChartType(CHART_TYPE.LINE_CHART)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.LINE_CHART)
    // }
    // navigate(`/line-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });
  }

  const openOFChart = () => {
    setShowTable(false)
    if (chartType != CHART_TYPE.OF_CHART) {
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel()
      // console.log("state=",state);
      setPollingAllowedVal(false)
      setChartType(CHART_TYPE.OF_CHART)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.OF_CHART)
    }
  }

  useEffect(() => {
    console.log(
      "Chart container Props changes, proUser",
      props.chartStateData,
      props.proUser
    )
  }, [props.chartStateData])

  



  

  

  //execute the data fetch on the component mount
  useEffect(() => {
 
    setIsDirty(true)
    setJsonData(undefined)
    setState((prevState) => ({
      ...prevState,
      isJsonLoaded: true,
      isFirtLoadComplete: true,
    }))
  }, [])

  useEffect(() => {
  
    if (selectedInstrument != undefined) {
    
      //save the current symbol in URL if its not in the bookmark view
      if (!searchParams.has("bookmarkID") && props.val == 0) {
        // setSearchParams({ symbol: selectedInstrument })
      }
      // setJsonData(undefined);
      setState((prevState) => ({
        ...prevState,
        // apiData:undefined,
        bookmarkData: undefined,
        // isJsonLoaded:false,
      }))
      setFooterLoaded(true)
     
    
      setIsDirty(true)
    }
  }, [selectedInstrument, selectedTimeFrame, toggleMPLoading])

  useState(() => {
    console.log("charttype,state", chartType, state)
  }, [state])
 




  

  /**
   * autoclosing of the snackbar msg bar
   */
  const handleClose = (event, reason) => {
    setMsgState({ ...msgState, open: false })
  }


  const setPollingAllowedVal = (val) => {
    setState((prevState) => ({
      ...prevState,
      isPollingAllowed: val,
    }))
  }

  

  

  const handleVPType = (val) => {
    setVPType(val)
  }

  const handleFooterLoaded = () => {
    setFooterLoaded(true)
  }

  const handleChartChange = (data) => {
    console.log("handleChartChange", data)
    if (!isChartOptionAccessAllowed(permissions, data)) {
      props.openSubscribeModal()
      return
    }
    setStateData(data)
    setChartType(data.data.chart_type)
    if (data?.data) {
      setPlotType(data.data.plot)
      setPlotData(data.data)
    }
  }

  const changeTimeFrame = (val) => {
    setState((prevState) => ({
      ...prevState,
      selectedTimeFrame: val,
    }))
  }

  
  useEffect(() => {
    selectedInstrumentRef.current = selectedInstrument
    console.log(
      "useeffect selectedinstrument",
      selectedInstrument,
      selectedInstrumentRef.current
    )
  }, [selectedInstrument])

  
  

 

  const showPriceTable = () => {
    console.log("showTable=", showTable)
    setShowTable(true)
  }

  const showSubscribeModal = (isCustom, msg) => {
    props.openSubscribeModal(isCustom, msg)
  }

 

 
  useEffect(() => {
    console.log("Boundary levelData useeffect chart container=", levelData)
    // loadDataLevel();
  }, [levelData])

  const openSunscriptionModal = (isCustom, msg) => {
    props.openSubscribePropModal(isCustom, msg)
  }

  useEffect(() => {
    let data = {
      symbol: "NIFTY",
      // instruments: 1,
      // tpoList: 1,
      additional_instruments: [symbol],
      dateList: 1,
    }
    executeAPIUiData(URL.MPCHART_UIDATA, "POST", data)
  }, [])

  /**
   * API response handler
   */
  useEffect(() => {
    if (loadedUiData) {
      if (responseDataUiData != null) {
        // console.log("Testing444 ",symbol,props.symbol,location)
        if(responseDataUiData.instruments) {
          responseDataUiData.instruments = responseDataUiData.instruments.map((item) =>
          transformAndReverseMap(item)
        );
        responseDataUiData.instruments = responseDataUiData.instruments.filter(
          (e) => e.line_chart === true
        )
        let index = 0;
        if (props.symbol != undefined && props.symbol != "") {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.instr === props.symbol
          )
          // console.log("Testing444 props",symbol,props.symbol,location,index)
          if (index == -1) index = 0
        } else if (props.val==0 && symbol != undefined && symbol != "") {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.instr === symbol
            // (item) => item.instr === props.symbol?props.symbol:symbol
          )
          // console.log("Testing444 query param",symbol,props.symbol,location,index,responseDataUiData.instruments)
          if (index == -1) index = 0
        } 
        else if (
          userSettings != undefined &&
          userSettings.data != undefined
        ) {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.name === userSettings.data.default_instrument
          )
          if (index == -1){
            index = responseDataUiData.instruments.findIndex(
              (item) => item.name === "NIFTY"
            )
          } 
          if (index == -1) index = 0
        }
        // setOptions(responseDataUiData.instruments)
        setInstrumentsData(responseDataUiData.instruments) // all data
        if(props.stateData==undefined&& props.val==0){
          // console.log("testing444 searchparams test line chart container=",props.stateData)
          setSearchParams({"symbol":responseDataUiData.instruments[index].instr})
        }
        // console.log("Testing444 index=",index)
        setSelectedInstrument(responseDataUiData.instruments[index].instr) // only name of selected data
        setSelectedInstrumentData(responseDataUiData.instruments[index]) // current selected all data
        }
        setInstrumentsLoaded(true);
        syncUidataNotifyFlags(responseDataUiData);
        
      //   setState((prevState) => ({
      // ...prevState,
      // isLoading:false,
      // }));

        // setTradeDates(responseData.tradeDates);
        // props.instrumentChange(
        //   responseData.instruments[index],
        //   responseData.tpo_groups[responseData.instruments[index].tpo_group]
        //     ? responseData.tpo_groups[responseData.instruments[index].tpo_group]
        //     : responseData.tpo_groups["DEFAULT"],
        //   tempTPO,
        //   responseData.tradeDates
        // );
        // setInstrumentLoaded(true);
      } else if (error !== null) {
        console.log("Error data=", error)
        reset()
      }
    }
  }, [loadedUiData, responseDataUiData])

  const instrumentChange = (data) => {
    console.log("Instrumentsdropdown =instrumentChange",props.val,data.instr)
    setSelectedInstrument(data.instr)
    setSelectedInstrumentData(data)
   
  }

  const setChartRenderedState=(val)=>{
    setState((prevState)=>({
      ...prevState,
      chartRendered:val
    }))

    if(props.setChartLoaded){
      // console.log("HelloTest val 1=",val)
      const timeout = setTimeout(() => {
        props.setChartLoaded(val);
    }, 1000);
  }
    
   }

   useEffect(() => {
    console.log("useEffect is called for props.stateData Line chart container",props.stateData)
   
    // if(instrumentsData && props.stateData){
    //   setInstrumentsLoaded(false);
    //   let index = responseDataUiData.instruments.findIndex((item) => item.instr === props.stateData.symbol)
    //   console.log("useEffect is called for props.stateData Line chart container 1",props.stateData,index)
    //   if(index!=-1){
    //     setSelectedInstrument(responseDataUiData.instruments[index].instr) // only name of selected data
    //     setSelectedInstrumentData(responseDataUiData.instruments[index]) // current selected all data
    //     }
    // }
    setStateData(props.stateData);
    if (props.stateData?.data) {
      setPlotType(props.stateData.data.plot)
      setPlotData(props.stateData.data)
    }
    // setInstrumentsLoaded(true);

  }, [props.stateData])

  const openSettings=()=>{
    setShowSettings(true);
   }
  
   const cancelSettings=()=>{
    setShowSettings(false);
   }
  
   const saveSettings=(settings)=>{
    console.log("MP Settings save settings in chart container",settings);
    setUserSettings(settings);
   }

   const changeInstrument=(instr)=>{
    setSelectedInstrument(instr)
   }
  return (
    <>
      {chartType == CHART_TYPE.MARKET_PROFILE ? (
      
        <ChartContainer
        id={props.id}
        val={props.val}
        boundClass={props.boundClass}
        chartScreenType={props.chartScreenType}
        setChartType={props.setChartType}
        chartStateData={props.chartStateData}
        symbol={selectedInstrument}
        resetRightPanel={props.resetRightPanel}
        setRightPanel={props.setRightPanel}
        openSubscribeModal={props.openSubscribePropModal}
        basicUser={props.basicUser}
        proUser={props.proUser}
        setChartLoaded={props.setChartLoaded}
        saveChartState={props.saveChartState}
        tabData={tabData}
      ></ChartContainer>
        )
       : (
        <>
          {chartType == CHART_TYPE.OF_CHART ? (
            <OrderflowContainer
              id={props.id}
              val={props.val}
              boundClass={props.boundClass}
              chartScreenType={props.chartScreenType}
              setChartType={props.setChartType}
              chartStateData={props.chartStateData}
              symbol={selectedInstrument}
              resetRightPanel={props.resetRightPanel}
              setRightPanel={props.setRightPanel}
              openSubscribeModal={props.openSubscribePropModal}
              basicUser={props.basicUser}
              proUser={props.proUser}
              setChartLoaded={props.setChartLoaded}
              saveChartState={props.saveChartState}
              tabData={tabData}
            ></OrderflowContainer>
          ) : (
            <></>
          )}
          {/* selectedInstudata, instrudata */}
          {console.log("Instrumentdropdown -1=",selectedInstrument,isLoading, instrumentsLoaded)}  
          {chartType == CHART_TYPE.LINE_CHART && instrumentsLoaded? (
            <LineChart
              id={props.id}
              val={props.val}
              stateData={stateData}
              symbol={selectedInstrument}
              nDays={userSettings.data.default_lc_ndays}
              selectedInstrumentData={selectedInstrumentData}
              selectedInstrument={selectedInstrument}
              instrumentsData={instrumentsData}
              instrumentChanged={changeInstrument}
              initialData={initialData}
              toggleState={toggleState}
              saveChartState={props.saveChartState}
              footerProps={{
                chartType,
                chartStateData: props.chartStateData,
                userSettings,
                selectedInstrumentData: selectedInstrumentData || {
                  instr: selectedInstrument || "NIFTY",
                  of: false,
                  line_chart: true,
                  cc: false,
                },
                openStockChart,
                selectedInstrument,
                openLineChart,
                basicUser: props.basicUser,
                handleVPType,
                handleFooterLoaded,
                handleChartChange,
                auth,
                showPriceTable,
                showTable,
                openSubscribeModal: showSubscribeModal,
                openOFChart,
                openMPChart,
                openSettings,
                timeFrame: selectedTimeFrame,
                changeTimeFrame,
                plot: plotType,
                plotData,
                isEliteUser,
                showTimeFrame: false,
              }}
            ></LineChart>
          ) : (
            <></>
          )}
          {chartType == CHART_TYPE.HV_CHART ? (
            <StockChartHV
              id={props.id}
              stateData={stateData}
              symbol={selectedInstrument}
              nDays={userSettings.data.default_lc_ndays}
            ></StockChartHV>
          ) : (
            <></>
          )}
          {chartType == CHART_TYPE.BAR_CHART ? (
            // <BarChart
            //   id={props.id}
            //   stateData={stateData}
            //   symbol={selectedInstrument}
            //   nDays={userSettings.data.default_lc_ndays}
            // ></BarChart>
            <BarChartContainer
            key={0}
            val={props.val}
            id={props.id}
            symbol={selectedInstrument}
            nDays={userSettings.data.default_lc_ndays}
            boundClass={props.boundClass}
            setChartType={props.setChartType}
            resetRightPanel={props.resetRightPanel}
            setRightPanel={props.setRightPanel}
            chartScreenType={props.chartScreenType}
            basicUser={props.basicUser}
            openSubscribeModal={props.openSubscribePropModal} 
            // openSubscribePropModal={showSubscribeProModal}
            proUser={props.proUser}
            chartStateData={props.chartStateData}
            stateData={stateData}
            setChartLoaded={props.setChartLoaded}
            saveChartState={props.saveChartState}
            tabData={tabData}
          />
          ) : (
            <></>
          )}

          {chartType != CHART_TYPE.OF_CHART && chartType != CHART_TYPE.MARKET_PROFILE && chartType != CHART_TYPE.BAR_CHART && chartType != CHART_TYPE.LINE_CHART && selectedInstrumentData ? (
            <LineChartFooterNew
              chartType={chartType}
              chartStateData={props.chartStateData}
              userSettings={userSettings}
              selectedInstrumentData={selectedInstrumentData}
              openStockChart={openStockChart}
              selectedInstrument={selectedInstrument}
              openLineChart={openLineChart}
              basicUser={props.basicUser}
              handleVPType={handleVPType}
              handleFooterLoaded={handleFooterLoaded}
              handleChartChange={handleChartChange}
              auth={auth}
              showPriceTable={showPriceTable}
              showTable={showTable}
              openSubscribeModal={showSubscribeModal}
              openOFChart={openOFChart}
              openMPChart={openMPChart}
              openSettings={openSettings}
              timeFrame={selectedTimeFrame}
              changeTimeFrame={changeTimeFrame}
              plot={plotType}
              plotData={plotData}
              isEliteUser={isEliteUser}
              showTimeFrame={false}
            />
          ) : (
            <></>
          )}
        </>
      )}
      {showSettings ? (
        isD3BasedLineChart(plotData.plot, plotData.doix) ? (
          <LineChartSettingsNew
            open={true}
            plotData={plotData}
            plot={plotType}
            cancelHandler={cancelSettings}
            saveHandler={saveSettings}
          />
        ) : (
          <LineChartSettings
            open={true}
            cancelHandler={cancelSettings}
            saveHandler={saveSettings}
          />
        )
      ) : (
        <></>
      )}
    </>
  )
}

export default LineChartContainer